// eslint-disable-next-line import-x/no-namespace
import * as Sentry from '@sentry/tanstackstart-react';
import { createRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';

import { DefaultCatchBoundary } from '@/components/router/DefaultCatchBoundary';
import { NotFound } from '@/components/router/NotFound';
import { clientSideQueryClient, createQueryClient } from '@/modules/QueryClient';
import { SearchSerializer } from '@/modules/SearchSerializer';
import { routeTree } from '@/routeTree.gen';

export function getRouter() {
  const queryClient = clientSideQueryClient ?? createQueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: NotFound,
    scrollRestoration: true,

    stringifySearch: SearchSerializer.stringify,
    parseSearch: SearchSerializer.parse,
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });

  if (!router.isServer) {
    const environment = document.querySelector('meta[name="sentry-environment"]')?.getAttribute('content');

    if (!environment) {
      throw new Error('Could not retrieve Sentry `environment` from meta tag');
    }

    Sentry.init({
      dsn: 'https://22e2656640a6442da790e384d22550d9@sentry.trafficon.eu/21',
      enabled: import.meta.env.MODE !== 'development',
      environment,
      release: import.meta.env.VITE_SENTRY_RELEASE,
      integrations: [
        Sentry.tanstackRouterBrowserTracingIntegration(router),
        Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
      ],

      enableLogs: true,

      tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.3,
    });
  }

  return router;
}
